// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-page > div:not(:first-child) {\n    margin-top: 16px;\n}\n\n.contact-spinner{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
